import { validatorFactory } from '@laam/lib/validator';
import * as Sentry from '@sentry/vue';
import { useQuery } from '@tanstack/vue-query';
import {
	type EasypaisaUserInfoResponse,
	EasypaisaUserInfoResponseType,
} from '~/types/easypaisa';

const easypaisaUserInfoResponseValidator =
	validatorFactory<EasypaisaUserInfoResponse>(EasypaisaUserInfoResponseType);

export const useEasypaisaUserInfoQuery = (
	authCode: Ref<string | null | undefined>,
) => {
	const enabled = computed(() => !!authCode.value);
	const { data, isLoading, isError, error, isSuccess, refetch, suspense } =
		useQuery({
			queryKey: ['easypaisa-user-info', authCode],
			enabled,
			retry: false,
			queryFn: async () => {
				const api = createApiInstance();
				const url = `v1/checkout/easypaisa/user?auth_code=${authCode.value}`;
				const response = await api.get(url);
				if (response.status === 200) {
					return easypaisaUserInfoResponseValidator.verify(response.data);
				}
				const err = new Error('Failed to fetch Easypaisa user info');
				Sentry.captureException(err, (scope) => {
					scope.setContext('response', response.data as any);
					return scope;
				});
				throw err;
			},
		});

	return { data, isLoading, isError, error, isSuccess, refetch, suspense };
};
